<div class="row">
  <div class="col-12">
    <h6 class="text-center routeEditGroupTitle mb-2">{{'DEVICES' | translate}}</h6>
    @if (deviceGroups.length == 0) {
      <p class="text-center mt-2">{{'NO_DEVICES' | translate}}</p>
    }
  </div>
</div>

<div class="row">
  @if (deviceGroups.length != 0) {
    <div class="col-lg-4 col-md-12 white-bg">
      <div class="card card-borders p-2">
        <h6 class="text-center devicesGroupTitle">{{'AVAILABLE_DEVICES' | translate}}</h6>
        <mat-list>
          @if (deviceGroups | anyAvailableDevices) {
            <mat-list-item>
              <div class="d-flex flex-row justify-content-between">
                <div>
                  <span class="fa-light fa-check-double mr-1" style="vertical-align: middle"></span>
                  <span class="devicesGroupTitle text-truncate">{{'ADD_ALL_DEVICES' | translate}}</span>
                </div>
                <mat-icon class="add-device-button" (click)="addAllDevices();">add_circle</mat-icon>
              </div>
            </mat-list-item>
          }
          @for (deviceTypeOption of availableDeviceTypeOptions; track deviceTypeOption) {
            @if (deviceTypeOption.deviceType | anyAvailableDevicesByType : deviceGroups) {
              <mat-list-item>
                <div class="d-flex flex-row justify-content-between">
                  <div class="text-truncate">
                    <span class="devicesGroupTitle">
                      {{'ALL' | translate}} -
                      {{ $safeNavigationMigration(deviceTypeOption?.deviceType) | deviceType }}
                    </span>
                  </div>
                  <mat-icon class="add-device-button" (click)="addDevicesByType(deviceTypeOption.deviceType)">
                    add_circle
                  </mat-icon>
                </div>
              </mat-list-item>
            }
          }
          @for (group of deviceGroups; track trackByLocationId($index, group)) {
            @if (group.locationId | availableDevicesInLocation : deviceGroups) {
              <mat-list-item>
                <div class="d-flex flex-row justify-content-between">
                  <div class="text-truncate">
                    @if (group.locationName) {
                      <span class="fa-fw mr-2 fa-solid fa-house devicesGroupTitle"></span>
                    }
                    <span class="devicesGroupTitle">{{ group.locationName }}</span>
                  </div>
                  <mat-icon class="add-device-button" (click)="addDevicesByLocationId(group.locationId)">
                    add_circle
                  </mat-icon>
                </div>
              </mat-list-item>
            }
            @for (device of group.deviceOptions; track trackByDeviceFn($index, device)) {
              @if (!device.selected) {
                <mat-list-item>
                  <div class="d-flex flex-row justify-content-between">
                    <div class="text-truncate">
                      <span [ngClass]="$safeNavigationMigration(device?.deviceType) | deviceIconClass" class="mr-1"
                        style="vertical-align: middle">
                      </span>
                      @if (device.deviceName) {
                        {{ device.deviceName }}
                      }
                      @if (!device.deviceName) {
                        {{ device.deviceId }}
                      }
                      ({{ device.deviceType | deviceType }})
                    </div>
                    <mat-icon class="add-device-button" (click)="addDevice(device); saveDevicesToTempRoute();">
                      add_circle
                    </mat-icon>
                  </div>
                </mat-list-item>
              }
              @for (pairedDevice of device.pairedDeviceOptions; track trackByDeviceFn($index, pairedDevice)) {
                @if (!pairedDevice.selected) {
                  <mat-list-item>
                    <div class="d-flex flex-row justify-content-between">
                      <div class="text-truncate">
                        <span [ngClass]="$safeNavigationMigration(pairedDevice?.deviceType) | deviceIconClass" class="mr-1"
                          style="vertical-align: middle">
                        </span>
                        @if (pairedDevice.deviceName) {
                          {{ pairedDevice.deviceName }}
                        }
                        @if (!pairedDevice.deviceName) {
                          {{ pairedDevice.deviceId }}
                        }
                        ({{ $safeNavigationMigration(pairedDevice?.deviceType) | deviceType }})
                      </div>
                      <mat-icon class="add-device-button" (click)="addDevice(pairedDevice); this.saveDevicesToTempRoute();">
                        add_circle
                      </mat-icon>
                    </div>
                  </mat-list-item>
                }
              }
            }
          }
        </mat-list>
      </div>
    </div>
    <!--Selected devices-->
    <div class="col-lg-4 col-md-12 white-bg">
      <div class="card card-borders p-2">
        <h6 class="text-center devicesGroupTitle">{{'SELECTED_DEVICES' | translate}}</h6>
        <mat-list>
          @if (deviceGroups | anySelectedDevices) {
            <mat-list-item>
              <div class="d-flex flex-row justify-content-between">
                <div>
                  <span class="fa-light fa-check-double mr-1" style="vertical-align: middle"></span>
                  <span class="devicesGroupTitle text-truncate">
                    {{ 'REMOVE_ALL_DEVICES' | translate }}
                  </span>
                </div>
                <mat-icon class="remove-device-button" (click)="removeAllDevices();">remove_circle</mat-icon>
              </div>
            </mat-list-item>
          }
          @for (deviceTypeOption of availableDeviceTypeOptions; track deviceTypeOption) {
            <div [ngClass]="{'highlight-selection' : deviceTypeOption.highlight}">
              @if ($safeNavigationMigration(deviceTypeOption?.deviceType) | deviceTypeFoundInGroups : deviceGroups) {
                <mat-list-item>
                  <div class="d-flex flex-row justify-content-between align-items-center">
                    <div class="text-truncate">
                      <span
                        class="devicesGroupTitle selection-container"
                                      (click)="
                                        highlightDeviceTypeOption(deviceTypeOption);
                                        selectedDevicesForActivations = getDevicesByType(deviceTypeOption.deviceType);
                                        deviceTypeGroupHighlighted = true;"
                        >
                        {{'ALL' | translate}} - {{ $safeNavigationMigration(deviceTypeOption?.deviceType) | deviceType }}
                      </span>
                    </div>
                    <mat-icon class="remove-device-button"
                      (click)="removeDevicesByType(deviceTypeOption.deviceType)">
                      remove_circle
                    </mat-icon>
                  </div>
                </mat-list-item>
              }
            </div>
          }
          @for (group of deviceGroups; track trackByLocationId($index, group)) {
            @if (group.locationId | foundInLocation : deviceGroups) {
              <mat-list-item>
                <div class="d-flex flex-row justify-content-between align-items-center">
                  <div class="text-truncate">
                    @if (group.locationName) {
                      <span
                      class="fa-fw mr-2 fa-solid fa-house devicesGroupTitle"></span>
                    }
                    <span class="devicesGroupTitle text-truncate">
                      {{ group.locationName }}
                    </span>
                  </div>
                  <mat-icon class="remove-device-button" (click)="removeDevicesByLocationId(group.locationId)">
                    remove_circle
                  </mat-icon>
                </div>
              </mat-list-item>
            }
            @for (device of group.deviceOptions; track trackByDeviceFn($index, device)) {
              <div [@addDeviceAnimation]="device.selected" [ngClass]="{'highlight-selection' : device.highlight}">
                @if (device.selected) {
                  <mat-list-item>
                    <div class="d-flex flex-row justify-content-between align-items-center">
                      <div
                        class="text-truncate selection-container d-flex align-items-center"
                                          (click)="highlightDeviceOption(device);
                                          deviceTypeGroupHighlighted = false;
                                          selectedDevicesForActivations = [device]"
                        >
                        <span
                          [ngClass]="$safeNavigationMigration(device?.deviceType) | deviceIconClass"
                          class="mr-1" style="vertical-align: middle">
                        </span>
                        <div [ngClass]="{'text-danger' : device?.activations.length === 0}"
                          class="d-inline">
                          @if (device.deviceName) {
                            {{device.deviceName}}
                          }
                          @if (!device.deviceName) {
                            {{device.deviceId}}
                          }
                          <span> ({{ device.deviceType | deviceType }})</span>
                        </div>
                      </div>
                      <mat-icon class="remove-device-button" (click)="removeDevice(device)">
                        remove_circle
                      </mat-icon>
                    </div>
                  </mat-list-item>
                }
              </div>
              @for (pairedDevice of device.pairedDeviceOptions; track trackByDeviceFn($index, pairedDevice)) {
                <div
                  [@addedAnimation]="device.selected"
                  [ngClass]="{'highlight-selection' : pairedDevice.highlight}"
                  class="mb-1"
                  >
                  @if (pairedDevice.selected) {
                    <mat-list-item>
                      <div class="d-flex flex-row justify-content-between align-items-center">
                        <div class="text-truncate selection-container d-flex align-items-center"
                                            (click)="highlightDeviceOption(pairedDevice);
                                                 deviceTypeGroupHighlighted = false;
                                                 selectedDevicesForActivations = [pairedDevice]">
                          <span [ngClass]="$safeNavigationMigration(pairedDevice?.deviceType) | deviceIconClass" class="mr-1"
                          style="vertical-align: middle"></span>
                          <div [ngClass]="{'text-danger' : pairedDevice?.activations.length === 0}"
                            class="d-inline">
                            @if (pairedDevice.deviceName) {
                              {{ pairedDevice.deviceName }}
                            }
                            @if (!pairedDevice.deviceName) {
                              {{ pairedDevice.deviceId }}
                            }
                            <span> ({{ pairedDevice.deviceType | deviceType }})</span>
                          </div>
                        </div>
                        <mat-icon class="remove-device-button" (click)="removeDevice(pairedDevice)">
                          remove_circle
                        </mat-icon>
                      </div>
                    </mat-list-item>
                  }
                </div>
              }
            }
          }
        </mat-list>
      </div>
    </div>
    <div class="col-lg-4 col-md-12 white-bg">
      <div class="card card-borders p-2 activations-list">
        <h6 class="text-center devicesGroupTitle">{{'ALARM_TYPE' | translate}}</h6>
        @if (!selectedDevicesForActivations[0]?.deviceId | foundInGroups : deviceGroups) {
          <p class="text-center">
            {{ 'NO_DEVICES_SELECTED' | translate }}
          </p>
        }
        @if (!deviceTypeGroupHighlighted && selectedDevicesForActivations[0]?.deviceId | foundInGroups : deviceGroups) {
          <p class="text-center">
            {{ selectedDevicesForActivations[0]?.deviceName }}
          </p>
        }
        @if (deviceTypeGroupHighlighted && selectedDevicesForActivations[0]?.deviceId | foundInGroups : deviceGroups) {
          <p class="text-center">
            {{ $safeNavigationMigration(selectedDevicesForActivations[0]?.deviceType) | deviceType }}
          </p>
        }
        @if ($safeNavigationMigration(selectedDevicesForActivations[0]?.deviceId) | foundInGroups : deviceGroups) {
          @for (selectedDeviceActivation of (selectedDevicesForActivations | mapDeviceActivation : allActivations : deviceTypeAvailableActivations) | keyvalue; track selectedDeviceActivation) {
            <mat-checkbox class="activation-checkbox"
              #checkbox
              [checked]="selectedDeviceActivation.value === 1"
              [indeterminate]="selectedDeviceActivation.value === 2"
                            (change)="!checkbox.checked
                                ? removeActivationFromDevices(selectedDeviceActivation.key.bindDeviceIds, selectedDeviceActivation.key)
                                : addActivationToDevices(selectedDeviceActivation.key.bindDeviceIds, selectedDeviceActivation.key)">
              <!-- Replace activation name if the name contains '%CTL%' -->
              @if (selectedDeviceActivation.key.name.includes('%CTL%')) {
                {{'NO_CONNECTION_WITHIN_TIME' | translate}}
              } @else {
                {{selectedDeviceActivation.key.name}}
              }
            </mat-checkbox>
          }
        }
      </div>
    </div>
  }
</div>
